import {
  AUTH_USER_REQUEST,
  AUTH_USER_SUCCESS,
  AUTH_USER_FAILURE,
} from "./action";

const initialState = {
  loading: false,
  data: {},
  error: "",
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case AUTH_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error:null
      };
    case AUTH_USER_FAILURE:
      localStorage.removeItem("token");
      return {
        loading: false,
        data: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
